const styles = {
  container: {
    padding: '20px',
    paddingTop: '140px',
    maxWidth: '1200px'
  },
  headerSection: {
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '24px',
    marginBottom: '30px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column'
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '20px',
    marginBottom: '20px'
  },
  preferencesGrid: {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))'
  },
  preferencesHeading: {
    color: '#183f7d',
    fontSize: '0.9rem',
    fontWeight: 600,
    margin: '0 0 4px'
  },
  section: {
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333333',
    margin: '0 0 16px 0',
    paddingBottom: '12px',
    borderBottom: '2px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center'
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '12px 0',
    borderBottom: '1px solid #f5f5f5',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  label: {
    fontWeight: '500',
    color: '#666666',
    minWidth: '150px',
    fontSize: '13px'
  },
  value: {
    color: '#333333',
    fontSize: '13px',
    wordBreak: 'break-word',
    flex: 1,
    textAlign: 'right'
  },
  valueHighlight: {
    color: '#005795',
    fontSize: '14px',
    fontWeight: '600',
    wordBreak: 'break-word',
    flex: 1,
    textAlign: 'right'
  },
  valueMono: {
    color: '#666666',
    fontSize: '12px',
    fontFamily: 'monospace',
    wordBreak: 'break-all',
    flex: 1,
    textAlign: 'right',
    backgroundColor: '#f5f5f5',
    padding: '8px',
    borderRadius: '4px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead': {
      backgroundColor: '#f5f5f5'
    },
    '& th': {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600',
      color: '#333333',
      borderBottom: '2px solid #e0e0e0',
      fontSize: '13px'
    },
    '& td': {
      padding: '12px',
      borderBottom: '1px solid #f0f0f0',
      fontSize: '13px',
      color: '#555555'
    },
    '& tbody tr:hover': {
      backgroundColor: '#f9f9f9'
    }
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px'
  }
};

export default styles;
